import UpdateExportDocumentationFee from "../UpdateExportDocumentationFee/UpdateExportDocumentationFee";

const ViewExportDocumentationFee = (props) => {
  return <UpdateExportDocumentationFee {...props} viewMode={true} />;
};

export default ViewExportDocumentationFee;
